import React, { Component } from "react";
import classnames from "classnames";
import { connect } from "react-redux";
import _ from "i18n";

import { createdDateFormat } from "Utils";
import Slide from "../Dashboard/Slide";
import { HideEye, ICONS, SvgIcon } from "../Common/Icons";
import styles from "./ExtraSLideItem.local.scss";
import { getLabelsByLng } from "../../utils";

class ExtraSlideItem extends Component {
  render() {
    const {
      slide,
      lng,
      extraSlidesInModal,
      backOffice,
      allowUpdateSlide
    } = this.props;
    return (
      <div className={classnames("medium-4", styles.slide_item)}>
        <ul style={{ display: "flex" }}>
          <li
            className={
              extraSlidesInModal
                ? classnames(styles.slide_card, styles.in_modal)
                : styles.slide_card
            }
            style={{ background: slide.hidden ? "#f5f5f5" : "#F8F9FA" }}
          >
            <div
              className={styles.slide_container}
              style={{ background: slide.hidden ? "#f5f5f5" : "#F8F9FA" }}
            >
              <div className={styles.item}>
                <Slide key={slide.id} slide={slide} isResponsive={false} />
              </div>
            </div>
            {!extraSlidesInModal ? (
              <div
                className={styles.informations_container}
                style={{ background: slide.hidden ? "#f5f5f5" : "#FFFFFF" }}
              >
                <div style={{ width: "265px" }}>
                  <h2 className={styles.title}>
                    {slide.layout.type === "EXTRA_SLIDE"
                      ? slide.label
                      : getLabelsByLng(slide.labels, lng)}
                  </h2>
                  <div className={styles.date}>
                    <span>
                      {_("createdAt")} {createdDateFormat(slide.createdAt, lng)}
                    </span>
                  </div>
                </div>
                <div className={styles.more_information}>
                  <div className={styles.actions_container}>
                    {(slide.status === "CREATED" || backOffice) &&
                    slide.layout.type !== "EXTRA_SLIDE" ? (
                      <div className={`row ${styles.actions} `}>
                        {allowUpdateSlide && (
                          <div
                            className={"medium-4"}
                            onClick={() =>
                              this.props.handleDisplayUpdateSlide(slide)
                            }
                          >
                            <SvgIcon icon={ICONS.EDIT_ICON} className={""} />
                          </div>
                        )}
                        <div
                          className={allowUpdateSlide ? "medium-4" : "medium-6"}
                          onClick={() => this.props.duplicateSlide(slide.id)}
                        >
                          <SvgIcon icon={ICONS.DUPLICATE_ICON} className={""} />
                        </div>
                        <div
                          onClick={() => this.props.deleteSlide(slide.id)}
                          className={classnames(
                            allowUpdateSlide ? `medium-4` : `medium-6`,
                            styles.delete_action
                          )}
                        >
                          <SvgIcon icon={ICONS.DELETE_ICON} className={""} />
                        </div>
                      </div>
                    ) : slide.status === "CREATED" ? (
                      <div className={`row ${styles.actions} `}>
                        <div
                          className={`medium-4`}
                          onClick={() =>
                            this.props.handleDisplayUpdateExtraSlide({ slide })
                          }
                        >
                          <SvgIcon icon={ICONS.EDIT_ICON} className={""} />
                        </div>
                        <div
                          className={`medium-4`}
                          onClick={() => this.props.hideSlide(slide)}
                        >
                          {slide.hidden ? (
                            <HideEye className={classnames(styles.hidden)} />
                          ) : (
                            <SvgIcon icon={ICONS.EyeIcon} className={""} />
                          )}
                        </div>
                        <div
                          onClick={() => this.props.deleteSlide(slide.id)}
                          className={classnames(
                            `medium-4`,
                            styles.delete_action
                          )}
                        >
                          <SvgIcon icon={ICONS.DELETE_ICON} className={""} />
                        </div>
                      </div>
                    ) : (
                      <div
                        className={`row ${styles.actions} `}
                        style={{ marginLeft: "40%" }}
                      >
                        <div
                          className={"medium-12"}
                          onClick={() => this.props.duplicateSlide(slide.id)}
                        >
                          <SvgIcon icon={ICONS.DUPLICATE_ICON} className={""} />
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            ) : (
              <div
                className={classnames(
                  styles.informations_container,
                  styles.list_extra_slides
                )}
                style={{ background: slide.hidden ? "#f5f5f5" : "#ffffff" }}
              >
                <div
                  style={{
                    width: "240px",
                    display: "flex",
                    justifyContent: "space-between"
                  }}
                >
                  <h2 className={styles.title}>{slide.label} </h2>

                  <div
                    className={styles.more_information}
                    style={{ marginTop: -18, marginRight: 10 }}
                  >
                    <div className={styles.actions_container}>
                      {
                        <div className={`row ${styles.actions} `}>
                          <div
                            className={"medium-12"}
                            onClick={() => this.props.handleSlideClicked(slide)}
                          >
                            <SvgIcon
                              icon={ICONS.SIMPLE_PLUS_ICON}
                              className={""}
                            />
                          </div>
                        </div>
                      }
                    </div>
                  </div>
                </div>
              </div>
            )}
          </li>
        </ul>
      </div>
    );
  }
}
// Connected Component
const mapStateToProps = state => ({
  slides: state.dashboardComposition.slides,
  lng: state.params.lng,
  extraSlidesInModal: state.preparePresentation.extraSlidesInModal,
  backOffice: state.params.backOffice
});

export default connect(mapStateToProps)(ExtraSlideItem);



// WEBPACK FOOTER //
// ./src/components/ExtraSlides/ExtraSlideItem.js